module.exports = __webpack_public_path__ + "static/media/tridot.e70c462c.png";